import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LivePoolItemWide from "./LivePoolItemWide";
import PoolListStatus from "./PoolListStatus";
import { fetchLivePools } from "../lib/livePools";
import { programKey } from "../lib/program";

const LivePageYesterday = () => {
  const [Pools, setPools] = useState([]);
  const [PageName, setPageName] = useState("");
  const [PoolVolume, setPoolVolume] = useState(-1);
  const [UtcHour, setUtcHour] = useState(0);
  const [ContentLoaded, setContentLoaded] = useState(false);
  const location = useLocation();

  const scrollToHash = useCallback(() => {
    if (location.hash) {
      const id = location.hash.substring(1);
      // console.log('Trying to scroll to:', id);
      const element = document.getElementById(id);
      if (element) {
        // console.log('Element found, scrolling...');
        element.scrollIntoView({ behavior: "smooth" });
        return true;
      } else {
        // console.log('Element not found');
        return false;
      }
    }
    return true;
  }, [location.hash]);

  useEffect(() => {
    (async () => {
      const loadPools = async () => {
        // if time now is before 7 am show yesterdays date, otherwise today
        const now = new Date();
        let temp_utc_hour = now.getUTCHours();
        setUtcHour(temp_utc_hour);
        // If it's before 5 AM UTC, we'll use yesterday's date
        if (temp_utc_hour < 5) {
          now.setUTCDate(now.getUTCDate() - 1);
        }
        const { pools, pageName } = await fetchLivePools(now);
        setPools(pools);
        setPageName(pageName);
        setPoolVolume(pools.length);
      };
      loadPools();
      setContentLoaded(true);
      const intervalId = setInterval(() => {
        loadPools(); // Fetch data every 2 min
      }, 120000);
      return () => clearInterval(intervalId);
    })();
  }, []);

  useEffect(() => {
    if (ContentLoaded) {
      // console.log('Content loaded, attempting to scroll');
      let attempts = 0;
      const maxAttempts = 10;
      const attemptInterval = 500; // 500ms between attempts

      const attemptScroll = () => {
        if (scrollToHash()) {
          // console.log('Scroll successful');
        } else if (attempts < maxAttempts) {
          attempts++;
          // console.log(`Attempt ${attempts} failed, trying again in ${attemptInterval}ms`);
          setTimeout(attemptScroll, attemptInterval);
        } else {
          // console.log('Max attempts reached, scroll failed');
        }
      };

      attemptScroll();
    }
  }, [ContentLoaded, scrollToHash]);

  return (
    <div className="row second">
      <div>
        <h1>{PageName}</h1>
        {UtcHour >= 5 ? (
          <p>
            <a href="/live-pool-projections-1" style={{ color: "grey", fontWeight: "bold" }}>
              Show Yesterday's Pool Projections
            </a>
          </p>
        ) : null}
        <br />
        <PoolListStatus poolVolume={PoolVolume} />
        {Pools.map((item) => (
          <React.Fragment key={programKey(item)}>
            <section id={item.programDate + "_" + item.programCode + "_" + item.race}>
              {item.PartitionKey.startsWith("SC") ? null : <LivePoolItemWide item={item} />}
            </section>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default LivePageYesterday;
